
import { MenuItem, ReservationSource, Table } from './types';

export const DEFAULT_TABLES: Table[] = [
  // Added default positions (percentage 0-100) for the floor map view feature
  { id: 't1', name: 'A', capacity: 2, position: { x: 15, y: 15 } },
  { id: 't2', name: 'B', capacity: 2, position: { x: 45, y: 15 } },
  { id: 't3', name: 'C', capacity: 2, position: { x: 75, y: 15 } },
  { id: 't4', name: 'D', capacity: 2, position: { x: 15, y: 55 } },
  { id: 't5', name: 'E', capacity: 2, position: { x: 45, y: 55 } },
  { id: 't6', name: 'F', capacity: 2, position: { x: 75, y: 55 } },
];

export const MENU_ITEMS: MenuItem[] = [
  {
    id: 'daily-special',
    name: '本日の健康日替わりプレート',
    description: '季節の野菜と玄米を使用した、身体に優しい日替わり定食。',
    price: 1600,
    category: 'food',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=400',
    isActive: true
  },
  {
    id: 'd-juice',
    name: 'フレッシュジュース',
    description: '搾りたての季節のフルーツジュース。',
    price: 600,
    category: 'drink',
    imageUrl: 'https://images.unsplash.com/photo-1613478223719-2ab802602423?auto=format&fit=crop&q=80&w=400',
    isActive: true
  },
  {
    id: 's-ice',
    name: 'バニラアイス',
    description: '濃厚なミルクの味わい。',
    price: 400,
    category: 'sweets',
    imageUrl: 'https://images.unsplash.com/photo-1560008581-09826d1de69e?auto=format&fit=crop&q=80&w=400',
    isActive: true
  },
  {
    id: 'c-500',
    name: '500円OFFクーポン',
    description: 'お会計から500円割引',
    price: -500,
    category: 'coupon',
    imageUrl: 'https://images.unsplash.com/photo-1513201099705-a9746e1e201f?auto=format&fit=crop&q=80&w=400', // Gentle gift/artistic image
    isActive: true
  }
];

export const CATEGORIES = [
  { id: 'all', label: 'すべて' },
  { id: 'food', label: 'フード' },
  { id: 'drink', label: 'ドリンク' },
  { id: 'sweets', label: 'スイーツ' },
  { id: 'coupon', label: 'クーポン' },
];

export const SOURCE_LABELS: Record<ReservationSource, { label: string, color: string, icon: string }> = {
  store: { label: '来店', color: 'bg-stone-100 text-stone-600', icon: '🏪' },
  phone: { label: '電話', color: 'bg-orange-100 text-orange-700', icon: '📞' },
  instagram: { label: 'Insta', color: 'bg-pink-100 text-pink-700', icon: '📸' },
  line: { label: 'LINE', color: 'bg-green-100 text-green-700', icon: '💬' },
};
